import React, {Component} from "react";

import "../common.css";

class Shop extends Component {
  handleClick = () => {
    window.open("https://pay.ldxp.cn/shop/promax", "_blank", "noopener,noreferrer");
  };

  render() {
    return (
      <div id="nice-menu-shop" className="nice-menu-item" onClick={this.handleClick}>
        <span>
          <span className="nice-menu-flag" />
          <span className="nice-menu-name">店铺</span>
        </span>
      </div>
    );
  }
}

export default Shop;
